export default {
  selection: "การเลือกภาษาระบบ",
  english: "English",
  simplified_chinese: "中文（简体）",
  list: {
    en: "ภาษาอังกฤษ",
    zh: "ภาษาจีน (CN)",
    tw: "ภาษาจีน (TW)",
    vi: "ภาษาเวียดนาม",
    th: "ภาษาไทย",
    id: "ภาษาอินโดนีเซีย",
    malay: "ภาษามลายู",
    jp: "ภาษาญี่ปุ่น",
    kr: "ภาษาเกาหลี",
    my: "พม่า",
    ar: "อาร์เจนตินา",
    ru: "รัสเซีย",
    ne: "เนปาล",
    bn: "เบงกาลี"
  }
};
